export const TOTALSCORE="TOTALSCORE"
export const CONTENTAFTERLOGIN="CONTENTAFTERLOGIN"
export const AFTERLOGOUT="AFTERLOGOUT"